export const timeZones = [ 
    { "description": "Eastern Standard Time", "abbr": "EST", "value": "America/Toronto" }, 
    { "description": "Pacific Standard Time", "abbr": "PST", "value": "America/Los_Angeles" }, 
    { "description": "Central Standard Time", "abbr": "CDT", "value": "America/Chicago" }, 
    { "description": "Eastern Daylight Time", "abbr": "EDT", "value": "America/New_York" }, 
    { "description": "Mountain Standard Time", "abbr": "MDT", "value": "America/Edmonton" },
    { "description": "Pacific Daylight Time", "abbr": "PDT", "value": "America/Vancouver" } 
]




